import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16 sm:py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <div className="max-w-3xl">
            <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl md:text-5xl lg:text-6xl">
              <span className="block">Excel in Your Studies with</span>
              <span className="block text-yellow-300 mt-2 sm:mt-3">Personalized Learning</span>
            </h1>
            <p className="mt-4 text-base text-blue-100 sm:text-lg md:mt-6 md:text-xl mx-auto max-w-2xl">
              Expert Grade 1–12 Math and Computer Science tutoring with flexible schedules and measurable results.
            </p>
            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <Link 
                to="/courses" 
                className="w-full sm:w-auto flex items-center justify-center px-6 py-3 sm:px-8 sm:py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-yellow-300 hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors duration-200"
              >
                View Our Courses
              </Link>
              <Link 
                to="/contact" 
                className="w-full sm:w-auto flex items-center justify-center px-6 py-3 sm:px-8 sm:py-3 border-2 border-white text-base font-medium rounded-md text-white bg-transparent hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white transition-colors duration-200"
              >
                Free Consultation
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;